import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { EmailOcrPngFile } from '@v2/modules/email-app/services/email-ocr.service';
import { OiqImagePreviewZoomComponent } from '@v2/shared/components/image-preview-zoom/image-preview-zoom.component';
import { EmailLayoutService } from '../../services/email-layout.service';
import { EmailPreviewService } from '../../services/email-preview.service';

@Component({
  selector: 'oiq-email-png-preview',
  standalone: true,
  imports: [CommonModule, OiqImagePreviewZoomComponent],
  templateUrl: './email-png-preview.component.html',
  styleUrl: './email-png-preview.component.scss',
})
export class EmailPngPreviewComponent {
  private emailPreviewService = inject(EmailPreviewService);
  private emailLayoutService = inject(EmailLayoutService);

  pngFiles = input.required<EmailOcrPngFile[]>();
  isVisible = input.required<boolean>();

  // TODO: Define types for mode input
  mode = input<'email-preview' | 'new-application'>();

  // Computed properties
  hasFiles = computed(() => this.pngFiles().length > 0);
  selectedFile = computed(() => this.pngFiles()[0] || null);

  onFileSelected(file: EmailOcrPngFile): void {}

  onClosePreview() {
    if (this.mode() == 'email-preview') {
      this.emailPreviewService.closePngPreview();
      this.emailLayoutService.openDetails();
    } else if (this.mode() == 'new-application') {
      this.emailPreviewService.closePngPreviewNewApp();
    }
  }
}
